import { Firebase } from '@insync/common';
import useFirebase from './useFirebase';
import FirebaseContext from './context';

export default Firebase;
export { useFirebase, FirebaseContext };
